import React from 'react'
import { inject, observer } from 'mobx-react'
import { policies, companies, rightsParamSets } from '@services/api'
import { Card, Button, Input, Layout, PageHeader, Row, Col, Select, DatePicker, Checkbox, Icon } from 'antd'

@inject((store: any) => {
    const { statisticsStore, companiesStore, logsStore } = store
    return { statisticsStore, companiesStore, logsStore }
})
@observer
export default class extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            sets: [],
            set: ''
        }
    }
    async componentDidMount() {
        await this.props.statisticsStore.getStatistics()
        await this.props.companiesStore.getCompanies()
        await rightsParamSets
            .getList()
            .then(res => this.setState({ sets: res.data }))
            .catch(err => console.log(err))
    }

    handleFilterChange = (name, value) => {
        this.props.statisticsStore.addFilter(name, value)
    }

    handleSubmitSearch = () => {
        const { filters } = this.props.statisticsStore
        const { sets } = this.state
        this.props.statisticsStore.getStatistics()
        this.setState({
            set: sets.find(set => set.id == filters.set) ? sets.find(set => set.id == filters.set).name : ''
        })
    }

    render() {
        const { users, filters, missings, duplicates, loading, resetFilters } = this.props.statisticsStore
        const { sets, set } = this.state
        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title="דוחות תיק ביטוחי"
                    subTitle={'דוחות סטטיסטיים על התיק הביטוחי של כלל הלקוחות'}
                />
                <Row gutter={10}>
                    <Col xs={4}>
                        <label>
                            <strong>חיפוש על פי תאריך הרשמה</strong>
                        </label>
                        <DatePicker.RangePicker
                            onChange={value => {
                                if (value[0]) this.handleFilterChange('gte', value[0].valueOf())
                                if (value[1]) this.handleFilterChange('lte', value[1].valueOf())
                                if (value.length === 0) resetFilters(['gte', 'lte'])
                            }}
                        />
                    </Col>
                    <Col xs={4}>
                        <label>
                            <strong>חיפוש על פי תאריך לידה</strong>
                        </label>
                        <DatePicker.RangePicker
                            onChange={value => {
                                if (value[0]) this.handleFilterChange('min_age', value[0].valueOf())
                                if (value[1]) this.handleFilterChange('max_age', value[1].valueOf())
                                if (value.length === 0) resetFilters(['min_age', 'max_age'])
                            }}
                        />
                    </Col>
                    <Col xs={5}>
                        <label>
                            <strong>סינון לפי קופת חולים</strong>
                        </label>
                        <Select
                            style={{ width: '100%' }}
                            value={filters.hmo}
                            placeholder="בחר קופת חולים"
                            onSelect={e => this.handleFilterChange('hmo', e)}
                        >
                            <Select.Option value={null} key={null}>
                                כל קופות החולים
                            </Select.Option>
                            {this.props.companiesStore.list
                                .filter(cmp => cmp.type == 'HMO')
                                .map((item, i) => {
                                    return (
                                        <Select.Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Select.Option>
                                    )
                                })}
                            <Select.Option value={142}>
                                <span>משרד הביטחון</span>
                            </Select.Option>
                        </Select>
                    </Col>
                    <Col xs={5}>
                        <label>
                            <strong>סינון לפי סטים</strong>
                        </label>
                        <Select
                            id="set_company_filter"
                            value={
                                sets.find(({ id }) => id == filters.set)
                                    ? sets.find(({ id }) => id == filters.set).name
                                    : 'כל הסטים'
                            }
                            style={{ width: '100%' }}
                            placeholder="בחר סט"
                            onSelect={e => this.handleFilterChange('set', e)}
                        >
                            <Select.Option value={null} key={null}>
                                כל הסטים
                            </Select.Option>
                            {sets.map(slot => (
                                <Select.Option value={slot.id} key={slot.id}>
                                    {slot.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: '0.5rem' }}>
                    <Col xs={6}>
                        <Button onClick={resetFilters} style={{ width: '45%' }}>
                            אפס חיפוש
                        </Button>
                        <Button onClick={this.handleSubmitSearch} style={{ width: '45%' }} type="primary">
                            חפש דוחות
                        </Button>
                    </Col>
                </Row>
                {!loading ? (
                    <>
                        <h5>
                            כלל התיקים הביטוחיים: <strong>{users}</strong>
                        </h5>
                        <h5>
                            חוסר ב{set ? set : 'אחד מהסטים האפשריים'}: <strong>{missings}</strong> | אחוז מכלל התיקים
                            הביטוחיים: <strong>{Math.round((missings / users) * 100) || 0}%</strong>
                        </h5>
                        <h5>
                            מספר הכפילויות ב{set ? set : 'אחד מהסטים האפשריים'}: <strong>{duplicates}</strong> | אחוז
                            מכלל התיקים הביטוחיים: <strong>{Math.round((duplicates / users) * 100) || 0}%</strong>
                        </h5>
                    </>
                ) : (
                    <Icon type="loading" />
                )}
            </Layout>
        )
    }
}
